var React = require('react');

function FilterIconInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#212121"},[React.createElement("path",{"d":"m12.5 0h-2.5v2.5h-2.5v2.5h7.5v-2.5h-2.5z","key":0}),React.createElement("path",{"d":"m12.5 6.25h-2.5v8.75h2.5z","key":1}),React.createElement("path",{"d":"m0 12.5h2.5v2.5h2.5v-2.5h2.5v-2.5h-7.5z","key":2}),React.createElement("path",{"d":"m5 0h-2.5v8.75h2.5z","key":3})]));
}

FilterIconInline.defaultProps = {"fill":"none","height":"15","viewBox":"0 0 15 15","width":"15"};

module.exports = FilterIconInline;

FilterIconInline.default = FilterIconInline;
